import { bankTransactionTypeEnum } from 'api-hooks/transactions/bank-transaction';
import { Input } from 'components/elements';
import { HalfContainer } from 'components/styles';
import BankAccountSelectInput from 'legacy-modules/master/bank-account/components/select-input';
import TransactionCategorySelectInput from 'legacy-modules/master/transaction-category/components/select-input';
import { SectionContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function TransactionSection() {
  const { t } = useTranslation();
  return (
    <>
      <HalfContainer>
        <TransactionCategorySelectInput name="transactionCategoryId" required />
      </HalfContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="select"
            name="type"
            label={t('common:type')}
            options={[
              {
                id: bankTransactionTypeEnum.debit,
                label: t(`common:${bankTransactionTypeEnum.debit}`),
              },
              {
                id: bankTransactionTypeEnum.credit,
                label: t(`common:${bankTransactionTypeEnum.credit}`),
              },
            ]}
            placeholder={t('common:type')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <BankAccountSelectInput name="bankAccountId" required />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="number"
            name="amount"
            label={t('common:amount')}
            placeholder={t('common:amount')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text-area"
            name="description"
            label={t('common:description')}
            placeholder={t('common:description')}
          />
        </HalfContainer>
      </SectionContainer>
    </>
  );
}
